// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tabbedNav":"_18YraIii77518EdjxV2eFj","tabbedNavItem":"I89N55Lv29w3Kmi3TgjjS","active":"_2PzZCGzczatsnmrLNJQz_z"};